import React from "react";

import Hero from "./Hero/Hero";
import HeroMobile from "./Hero/HeroMobile";
import Vission from "./Vission/Vission";
import Mission from "./Mission/Mission";
import Values from "./Values/Values";

// fetching
import { useEffect, useState } from "react";
import useFetch from "Hooks/useFetch";
import IsLoading from "Components/RequestHandler/IsLoading";
import IsError from "Components/RequestHandler/IsError";
const About = () => {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData, error } = useFetch();

  const getData = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await fetchData("about-us");
      setData(data?.about);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  if (isLoading) return <IsLoading />;
  if (error || isError) return <IsError />;
  if (data) {
    return (
      <main>
        <Hero data={data?.hero} />
        <HeroMobile data={data?.hero} />
        <Vission data={data?.vision} />
        <Mission data={data?.mission} />
        <Values data={data?.our_values} />
      </main>
    );
  }
};

export default About;
